export default __webpack_public_path__ + "static/media/logo_grad.08e10d63.png";